module.exports = __webpack_public_path__ + "img/preview-lg.44197e59.png";